<template>
  <div class="material-composition">
    <div v-for="(row, index) in materialList" :key="index" class="material-row">
      <el-select
        v-model="row.material"
        placeholder="请选择"
        filterable
        default-first-option
        style="width: 180px"
        @change="updateValue"
      >
        <el-option v-for="opt in materialOptions" :disabled="disabled(opt.value)" :key="opt.vid" :label="opt.value" :value="opt.value"> </el-option>
      </el-select>
      <el-input-digit
        v-model="row.percentage"
        :max="100"
        :precision="2"
        style="width: 90px"
        append="%"
        @change="updateValue"
      >
      </el-input-digit>
      <el-button type="link" class="delete-btn" @click="removeRow(index)"> 删除 </el-button>
    </div>
    <div class="add-row">
      <el-button type="link" @click="addRow" :disabled="materialList.length >= maxCount">
        + 继续添加 ({{ materialList.length }}/{{ maxCount }})
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pdd-material-composition',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
    value: {
      type: [Object, Array],
      default() {
        return [];
      },
    },
    options: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      materialList: [],
      maxCount: 7, // 最多添加 7 个材质
      localValue: [], // 本地值，用于触发校验
    };
  },
  computed: {
    materialOptions() {
      return this.options || this.item?.values || [];
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.parseValue(val);
      },
      deep: true,
    },
  },
  methods: {
    disabled(value) {
      const selecteds = this.materialList?.map(row => row.material).filter(v => v !== undefined || v !== '') || []
      return selecteds.includes(value)
    },
    parseValue(val) {
      // 材质成分数据解析：每个 item 是一个材质行，vvalue 是材质名，tableInfoDto.tableValueList[0].value 是百分比含量
      if (Array.isArray(val) && val.length > 0) {
        const parsedList = val.map(v => ({
          material: v.vvalue || '',
          percentage: v.tableInfoDto?.tableValueList?.[0]?.value ? parseFloat(v.tableInfoDto.tableValueList[0].value) : null,
          refPid: v.refPid,
          vid: v.vid,
          templatePid: v.templatePid,
          checked: v.checked,
          punit: v.punit,
          valueUnit: v.valueUnit,
        }));
        this.materialList = parsedList;
      } 
    //   else if (this.materialList.length === 0) {
    //     this.materialList = [{ material: '', percentage: null }];
    //   }
    },
    addRow() {
      if (this.materialList.length < this.maxCount) {
        this.materialList.push({ material: '', percentage: null });
        this.updateValue();
      }
    },
    removeRow(index) {
      this.materialList.splice(index, 1);
      this.updateValue();
    },
    updateValue() {
      const outputValue = this.getOutputValue();
      this.$nextTick(() => {
        this.$emit('change', outputValue);
      })
    },
    getOutputValue() {
      return this.materialList.map(row => {
        const tableInfoDto = {
          tableValueList: [],
        };
        // 添加材质含量信息
        if (row.percentage !== null && row.percentage !== undefined) {
          tableInfoDto.tableValueList.push({
            columnType: 1,
            unit: '%',
            value: String(row.percentage),
          });
        }
        const vid = this.materialOptions.find(op => op.value == row.material)?.vid || 0;
        return {
          checked: row.checked ?? true,
          punit: row.punit || '',
          refPid: row.refPid || this.item?.refPid,
          templatePid: row.templatePid, // 材质成分的 templatePid
          valueUnit: row.valueUnit || '',
          vid,
          vvalue: row.material,
          tableInfoDto: Object.keys(tableInfoDto.tableValueList).length > 0 ? tableInfoDto : undefined,
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.material-composition {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}
.material-row {
  display: flex;
  align-items: center;
  gap: 8px;
  .delete-btn {
    color: #f56c6c;
    padding: 0;
    margin-left: 4px;
  }
}
.add-row {
  margin-top: 4px;
  display: flex;
  align-items: center;
  gap: 12px;
  ::v-deep .el-button--text {
    color: #409eff;
  }
  .total-label {
    font-size: 14px;
    color: #606266;
    &.total-error {
      color: #f56c6c;
    }
    .error-tip {
      font-size: 12px;
    }
  }
}
</style>
